import { render } from "./dpp-nearbyafford.vue?vue&type=template&id=39b1bb3e"
import script from "./dpp-nearbyafford.js?vue&type=script&lang=js"
export * from "./dpp-nearbyafford.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__